<template>
  <card id="customerData">
    <!-- Card header -->

    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 slot="header" class="mb-0">
          <i :class="icon"></i>
          {{ title }}
        </h3>
      </b-col>
    </b-row>

    <!-- Card body -->
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form
        class="needs-validation"
        @submit.prevent="handleSubmit(firstFormSubmit)"
      >
        <b-row>
          
          <!-- b-col md="6">
                      <b-form-checkbox class="mb-3" v-model="offer.is_company">
                        Kunde ist ein Unternehmen
                      </b-form-checkbox>
                    </b-col -->

          <b-col md="6" v-if="offer.is_company">
            <base-input
              prepend-icon="fas fa-university"
              placeholder="Name des Unternehmens"
              name="Name des Unternehmens"
              :rules="{
                required_if:
                  { target: 'offer.is_company', values: true }
                  | { regex: /[a-zA-Z0-9\s\d\w]*./ },
              }"
              v-model="offer.company_name"
            ></base-input>
          </b-col>
        </b-row>

        <b-row v-if="!offer.is_company">
          <b-col md="6">
            <base-input rules="required" name="Titel">
              <el-select  :disabled="sf_enabled"
                v-model="offer.title"
                filterable
                placeholder="Titel"
              >
                <el-option
                  v-for="option in offer.customer_titles"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </b-col>

          <b-col md="6">
            <base-input
              prepend-icon="fas fa-user"
              placeholder="Vorname"
              v-model="offer.customer_first_name"
              name="Vorname"
              :rules="{ required: true | { regex: /[a-zA-Z0-9\s\d\w]*./ } }"
            ></base-input>
          </b-col>

          <b-col md="6">
            <base-input
              prepend-icon="fas fa-user"
              placeholder="Nachname"
              v-model="offer.customer_last_name"
              name="Nachname"
              :rules="{ required: true | { regex: /[a-zA-Z0-9\s\d\w]*./ } }"
            ></base-input>
          </b-col>
        </b-row>

        <b-row>
          

          <b-col md="6" v-if="!offer.is_company">
            <h4>Geburtsdatum</h4>
            <base-input
              prepend-icon="fas fa-calendar"
              v-model="offer.dob"
              type="date"
              name="Geburtsdatum"
              rules="required"
              placeholder="DD.MM.YYYY"
            >
            </base-input>
          </b-col>

          <b-col md="6">
            <h4>PLZ</h4>
            <base-input rules="required" name="Ort">
              <el-select
                v-model="offer.customer_zip"
                filterable
                remote
                placeholder="PLZ eingeben"
                :remote-method="search"
                :loading="loading"
                @input="getZipFromSelection"
                ref="selectRef"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <h4>Abweichender Halter:</h4>

            <b-form-radio-group
              v-model="offer.has_holder"
              v-on:change="changeHasHolder"
            >
              <div>
                <b-form-radio value="1" name="unchecked" class="mb-3">
                  Ja
                </b-form-radio>
                <b-form-radio value="0" name="checked" class="mb-3">
                  Nein
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>

<!-- 
car: {{ offer.is_car }} <br>
van: {{ offer.is_van }} <br>
is_company: {{ offer.is_company }} <br>
-->

          <Transition name="slide-fade">

            
            <template v-if="offer.is_car">
            <b-col md="6" v-if="offer.has_holder == 1" class="alerts-border">
              <h4>Bitte abweichenden Halter auswählen: </h4>
              <base-input
                name="Fahrzeughalter"
                :rules="{
                  required_if: { target: 'offer.has_holder', values: true },
                }"
              >
                <el-select
                  v-model="offer.holder_id"
                  filterable
                  placeholder="Fahrzeughalter"
                >

                <template v-if="offer.is_company">

                  <el-option
                    v-for="option in offer.KRAVAG_HOLDERS_CAR_COMPANY"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>

                </template>

                <template v-if="!offer.is_company">

                  <el-option
                    v-for="option in offer.KRAVAG_HOLDERS_CAR_PRIVAT"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>

                </template>

                </el-select>
              </base-input>
            </b-col>
            </template>

            <template v-if="(offer.is_van && offer.is_company == 1)">
            <b-col md="6" v-if="offer.has_holder == 1" class="alerts-border">
              <h4>Bitte abweichenden Halter auswählen: </h4>
              <base-input
                name="Fahrzeughalter"
                :rules="{
                  required_if: { target: 'offer.has_holder', values: true },
                }"
              >
                <el-select
                  v-model="offer.holder_id"
                  filterable
                  placeholder="Fahrzeughalter"
                >
                <template v-if="offer.is_company">

                  <el-option
                    v-for="option in offer.KRAVAG_HOLDERS_VAN_COMPANY"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>

                </template>

                <template v-if="!offer.is_company">

                  <el-option
                    v-for="option in offer.KRAVAG_HOLDERS_VAN_PRIVAT"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>

                </template>
                </el-select>
              </base-input>
            </b-col>
            </template>

            <template v-if="(offer.is_van && offer.is_company == 0)">
            <b-col md="6" v-if="offer.has_holder == 1" class="alerts-border">
              <h4>Bitte abweichenden Halter auswählen: </h4>
              <base-input
                name="Fahrzeughalter"
                :rules="{
                  required_if: { target: 'offer.has_holder', values: true },
                }"
              >
                <el-select
                  v-model="offer.holder_id"
                  filterable
                  placeholder="Fahrzeughalter"
                >
                  <el-option
                    v-for="option in offer.KRAVAG_HOLDERS_VAN_PRIVATE"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </b-col>
            </template>

          </Transition>

          <Transition name="slide-fade">
            <b-col md="6"></b-col>
          </Transition>
          <Transition name="slide-fade">
            <b-col md="6" v-if="offer.has_holder == 1">
              <h4>Bitte PLZ des Fahrzeughalters angeben</h4>
              <base-input rules="required" name="Ort">
                <el-select
                  v-model="offer.holder_zip"
                  filterable
                  remote
                  placeholder="PLZ eingeben"
                  :remote-method="search"
                  :loading="loading"
                  @input="getHolderZipFromSelection"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </b-col>
          </Transition>
        </b-row>
      </form>
    </validation-observer>
  </card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "customer",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    "v-select": vSelect,
  },
  data() {
    return {
      date_value: "",
      formatted: "",
      selected: "",

      labels: {
        de: {
          labelPrevDecade: "Vorheriges Jahrzehnt",
          labelPrevYear: "Vorheriges Jahr",
          labelPrevMonth: "Vorheriger Monat",
          labelCurrentMonth: "Aktueller Monat",
          labelNextMonth: "Nächster Monat",
          labelNextYear: "Nächstes Jahr",
          labelNextDecade: "Nächstes Jahrzehnt",
          labelToday: "Heute",
          labelSelected: "Ausgewähltes Datum",
          labelNoDateSelected: "Kein Datum gewählt",
          labelCalendar: "Kalender",
          labelNav: "Kalendernavigation",
          labelHelp: "Mit den Pfeiltasten durch den Kalender navigieren",
        },
      },

      loading: false,
      options: [],
      list: [],
      value: [],
      showHolder: false,
      writtenHolder: "",
      zipcode: "",
      dates: {
        simple: new Date(),
        range: "2019-04-19 to 2019-04-24",
      },

      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altInput: true,
        //dateFormat: "d.m.Y",
        //date: '01.01.2002',
        //date: '2002-01-01',
        //maxDate: '01.01.2002',
      },
      selectTitleOptions: [
        {
          label: "Herr",
          value: "Herr",
        },
        {
          label: "Frau",
          value: "Frau",
        },
        {
          label: "Divers",
          value: "Divers",
        },
      ],
    };
  },
  methods: {
  
    onContext(ctx) {
      console.log(ctx);
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },

    search(query) {
      if (query !== "") {
        this.loading = true;
        this.$api
          .getKravagLocations(query)
          .then((response) => {
            this.options = [];
            this.options = response.data.items.map((item) => {
              return { value: item.id, label: item.city, plz: item.plz };
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getHolderZipFromSelection(klid) {
      //console.log("get zip from slection");
      //this.zipcode = this.options.find( zip => zip.value === klid);
      this.offer.holder_zip = this.options.find(
        (zip) => zip.value === klid
      ).plz;

      this.offer.holder_kravag_location_id = klid;

      this.offer.holder_city = this.options.find(
        (zip) => zip.value === klid
      ).label;

      //console.log(this.zipcode);
      // const result = inventory.find( fruit => fruit.name === 'cherries' );
    },
    getZipFromSelection(klid) {
      //console.log("get zip from slection");
      //this.zipcode = this.options.find( zip => zip.value === klid);
      this.offer.customer_zip = this.options.find(
        (zip) => zip.value === klid
      ).plz;

      this.offer.kravag_location_id = klid;

      this.offer.customer_city = this.options.find(
        (zip) => zip.value === klid
      ).label;
      //console.log(this.zipcode);
      // const result = inventory.find( fruit => fruit.name === 'cherries' );
    },
    toggleHolder: function () {
      this.showHolder = !this.showHolder;
    },
    currentHolder: function () {
      this.offer.KRAVAG_HOLDERS_CAR.find((holder) => {
        if (holder.value === this.offer.holder_id) {
          this.writtenHolder = holder.label;
        }
      });
    },

    changeHasHolder(s) {
      if (s == 0) {
        this.offer.holder_id = "N";
        this.offer.holder_zip = "";
        this.offer.holder_kravag_location_id = "";
      }
      else{
        this.offer.holder_id = "";
      }
    },
  },

  watch: {




    has_holder(newValue, oldValue) {
      if (newValue == "1") {
        //        this.offer.holder_id = '';
      } else {
        this.offer.holder_id = "N";
      }
    },

    holder(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.currentHolder();
      // this.toggleHolder();
      // Do whatever makes sense now
      if (newValue === "success") {
        this.complex = {
          deep: "some deep object",
        };
      }
      if (newValue != "N") {
        //   this.offer.has_holder = true;
      } else {
        //   this.offer.has_holder = false;
        this.offer.holder_kravag_location_id = "";
      }
    },
    customer_dob(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      if (only_driver) {
        this.offer.youngest_driver_dob = this.offer.dob;
        this.offer.oldest_driver_dob = this.offer.dob;
      }
    },
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
      holder: (state) => state.offer.holder_id,
      customerAddress: (state) => state.customerAddress,
      customer_dob: (state) => state.offer.dob,
      second_vehicle: (state) => state.offer.has_second_vehicle,
      only_driver: (state) => state.offer.holder_only_driver,
      dob: (state) => state.offer.dob,
      has_holder: (state) => state.offer.has_holder,
      holder_id: (state) => state.offer.holder_id,
      car_first_registration: (state) => state.offer.car_first_registration,
      mileage: (state) => state.offer.mileage,
      insurance_start: (state) => state.offer.insurance_start,
      participation: (state) => state.offer.participation,
      paymentterm: (state) => state.offer.paymentterm,
      // holder_zip: (state) => state.offer.holder_zip,
    }),
  },

  mounted() {
    this.currentHolder();
  },
};
</script>
<style>
</style>